import React from "react"
import glamorous from "glamorous"

export default ({ ...props }) => <Container>{props.children}</Container>

const Container = glamorous.div({
  color: "red",
  paddingBottom: "3rem",
  alignSelf: "center",
})



// WEBPACK FOOTER //
// ./src/components/Form/FormFields/ErrorMessage/index.js